import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function ConfigColorIcon({ className, style, ...props }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 24 28'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_2299_48394)'>
        <path
          d='M12.6411 0C13.284 0.155728 13.7941 0.522189 14.257 0.990802C16.0562 2.81097 17.8642 4.62327 19.681 6.42772C20.2897 7.03349 20.6247 7.73355 20.5754 8.60505C20.559 8.89079 20.5754 9.17653 20.5711 9.46227C20.5625 9.95732 20.1911 10.3045 19.6896 10.3045C19.5779 10.3073 19.4668 10.2879 19.3626 10.2474C19.2585 10.2068 19.1635 10.1459 19.0832 10.0682C19.0029 9.99056 18.9388 9.89767 18.8948 9.79498C18.8507 9.6923 18.8276 9.58186 18.8267 9.47013C18.8156 9.2829 18.8156 9.09517 18.8267 8.90794C18.8481 8.66649 18.7681 8.58291 18.5152 8.58505C17.1965 8.5972 15.8771 8.5922 14.5584 8.59005C14.2187 8.59398 13.8815 8.52996 13.5668 8.40176C13.2522 8.27356 12.9663 8.08377 12.726 7.84353C12.4856 7.60329 12.2958 7.31745 12.1675 7.00279C12.0392 6.68814 11.9751 6.35103 11.9789 6.01125C11.9789 4.6897 11.9732 3.36816 11.9839 2.04733C11.9839 1.8023 11.9168 1.7273 11.6682 1.72801C8.70934 1.73587 5.75122 1.73158 2.79239 1.73373C2.07804 1.73373 1.74944 2.06518 1.74944 2.78811C1.74944 10.0745 1.74944 17.3608 1.74944 24.6472C1.74944 25.3687 2.07804 25.698 2.79596 25.6987C4.96139 25.6987 7.12682 25.6987 9.29225 25.6987C9.84302 25.6987 10.1895 25.9302 10.2881 26.3602C10.3931 26.8181 10.1909 27.1846 9.698 27.4317H2.10661C2.05589 27.416 2.00589 27.3989 1.95445 27.3846C0.730059 27.0353 0.00356564 26.0745 0.00356564 24.7994C0.00356564 17.4016 0.00356564 10.0038 0.00356564 2.60595C-0.00270408 2.1675 0.100413 1.73441 0.303592 1.34583C0.692198 0.611483 1.32368 0.202875 2.11018 0.000713957L12.6411 0ZM13.7284 3.0767C13.7284 3.98607 13.7284 4.88544 13.7284 5.7848C13.7284 6.50701 14.0562 6.83633 14.7727 6.83847C15.6009 6.84133 16.4293 6.84133 17.258 6.83847C17.3294 6.83847 17.4165 6.86918 17.4644 6.82347L13.7284 3.0767Z'
          fill='url(#paint0_linear_2299_48394)'
        />
        <path
          d='M15.4192 27.4312C14.6892 27.3126 13.9655 27.1647 13.2876 26.8597C10.6145 25.6453 9.00151 23.5973 8.61647 20.6713C8.07428 16.5574 10.8645 12.8849 14.777 12.1212C19.2167 11.2547 23.1999 14.2722 23.8893 18.4075C24.5843 22.5829 21.8891 26.4954 17.7594 27.3226C17.5508 27.364 17.3401 27.394 17.1301 27.4319L15.4192 27.4312ZM16.2843 13.7385C13.0126 13.7914 10.3402 16.2952 10.3216 19.6998C10.3038 22.9458 12.8219 25.6532 16.2507 25.6796C19.5225 25.7046 22.2191 23.1329 22.2255 19.7191C22.2348 16.4152 19.6567 13.8114 16.2864 13.7385H16.2843Z'
          fill='url(#paint1_linear_2299_48394)'
        />
        <path
          d='M17.1508 18.4967V18.8053C17.1508 20.2611 17.1508 21.7162 17.1508 23.1714C17.1525 23.3604 17.0909 23.5445 16.9758 23.6944C16.8607 23.8443 16.6988 23.9514 16.5158 23.9986C16.3334 24.0477 16.1402 24.0378 15.9638 23.9705C15.7874 23.9031 15.6368 23.7817 15.5335 23.6235C15.438 23.4613 15.3928 23.2743 15.4035 23.0864C15.4064 21.6577 15.4064 20.229 15.4035 18.8003C15.4035 18.7053 15.4264 18.606 15.3614 18.4724C15.0378 18.7953 14.7256 19.106 14.4156 19.4182C14.2191 19.6146 13.9963 19.7411 13.7062 19.7353C13.3626 19.7289 13.1019 19.5853 12.9412 19.286C12.8642 19.1488 12.8255 18.9934 12.829 18.8361C12.8326 18.6788 12.8782 18.5253 12.9612 18.3917C12.9967 18.3296 13.0402 18.2725 13.0905 18.2216C13.9398 17.3687 14.7849 16.5108 15.6443 15.6671C16.0207 15.2978 16.5393 15.2992 16.9179 15.6707C17.7709 16.5079 18.6152 17.3537 19.451 18.2081C19.623 18.3748 19.722 18.6028 19.7263 18.8423C19.7306 19.0818 19.6398 19.3133 19.4739 19.486C19.1267 19.8346 18.5667 19.8232 18.1773 19.451C17.8559 19.1424 17.5423 18.8253 17.2244 18.5131C17.218 18.5074 17.2051 18.5088 17.1508 18.4967Z'
          fill='url(#paint2_linear_2299_48394)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_2299_48394'
          x1='0.0032959'
          y1='0'
          x2='21.3476'
          y2='0.610758'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2299_48394'
          x1='8.54907'
          y1='11.9722'
          x2='24.5644'
          y2='12.5827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2299_48394'
          x1='12.8288'
          y1='15.3911'
          x2='19.9829'
          y2='15.609'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <clipPath id='clip0_2299_48394'>
          <rect width='24' height='27.431' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
